import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteValidationAllocationThunk,
  getValidationProductThunk,
} from "store/reducers/product/validationAllocationSlice";
import { validationAllocationSelector } from "store/reducers/product/validationAllocationSlice";

const ValidationAllocationList = ({ product_id, fullGrid }) => {
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  useEffect(() => {
    dispatch(getValidationProductThunk({ pid: product_id }));
  }, [product_id]);
  const validationAllocations = useSelector(
    validationAllocationSelector.selectAll
  ).filter((item) => item.product === product_id);
  const removeOffer = (id) => {
    dispatch(deleteValidationAllocationThunk(id));
  };
  const { status } = useSelector((state) => state.validationAllocation);

  const removeValidation = (id) => {
    dispatch(deleteValidationAllocationThunk(id));
  };
  return (
    <Box>
      {validationAllocations.length > 0 && (
        <>
          <Box
            component={Typography}
            variant="h4"
            sx={{ textDecoration: "underline", color: "text.secondary", mb: 1 }}
          >
            Allocated validations
          </Box>
          <Grid container>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Box
                sx={{ backgroundColor: "#e7ebf0", borderRadius: 2, flex: 1 }}
                padding={1}
              >
                <TableContainer component={Paper}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ minWidth: 100 }}>
                          {(isSmallScreen || fullGrid)  ? "Name" : "Validation name"}
                        </TableCell>
                        {!fullGrid && (
                          <TableCell align="center" sx={{ minWidth: 120 }}>
                            {isSmallScreen ? "Desc" : "Validation description"}
                          </TableCell>
                        )}

                        <TableCell align="center">
                          {(isSmallScreen || fullGrid)? "Logic" : "Logic code"}
                        </TableCell>
                        <TableCell align="center" sx={{ minWidth: 100 }}>
                          Image
                        </TableCell>
                        <TableCell>&nbsp;</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {validationAllocations.map(
                        ({ validation_detail, id }) => (
                          <TableRow
                            key={id}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell component="th" scope="row">
                              {validation_detail.name}
                            </TableCell>
                            {!fullGrid && (
                              <TableCell align="center">
                                {validation_detail.desc}
                              </TableCell>
                            )}

                            <TableCell align="center">
                              {validation_detail.logic}
                            </TableCell>
                            <TableCell align="center">
                              {validation_detail.image ? (
                                <LazyLoadImage
                                  width={100}
                                  height={100}
                                  src={validation_detail.image}
                                  style={{ objectFit: "contain" }}
                                />
                              ) : (
                                <Typography color="text.secondary">
                                  None
                                </Typography>
                              )}
                            </TableCell>

                            <TableCell align="center">
                              <LoadingButton
                                variant="outlined"
                                color="error"
                                onClick={() => {
                                  removeValidation(id);
                                }}
                                loading={
                                  status?.loading === "delete" &&
                                  status?.id === id
                                }
                              >
                                Delete
                              </LoadingButton>
                            </TableCell>
                          </TableRow>
                        )
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  );
};

export default ValidationAllocationList;
